import React, { useEffect } from 'react';
import './PassengerDetails.css'; // Import the CSS file
import arrow from "../../../../../../assets/arrow_back.svg"
import badge from "../../../../../../assets/Id badge.svg"
import age from "../../../../../../assets/calendar_month.svg"
import transgender from "../../../../../../assets/transgender.svg"
import seat from "../../../../../../assets/airline_seat_recline_extra.svg"
import Email from "../../../../../../assets/Email.svg"
import number from "../../../../../../assets/Call.svg"
import org from "../../../../../../assets/organization.svg"
import address from "../../../../../../assets/address.svg"
import { Box, Text } from 'grommet';
import Accordion from './common/Accordian/Accordian';
import { useNavigate, useParams } from 'react-router-dom';
import PassengerService from '../../../../../../services/passenger/passenger.service';
import { observer } from 'mobx-react';
import { useStore } from '../../../../../../Hooks/useStore';

function PassengerDetails() {
  const { passengerId } = useParams();
  const { rootStore } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const PassengerResponse = await PassengerService.getPassenger(passengerId);
        console.log("PassengerResponse",PassengerResponse);
        rootStore.passengerDetailStore.setPassenger(PassengerResponse);
      } catch (error) {
        console.log("Error in get passenger in passenegr detail.",error);
      }
    })();
    
    (async () => {
      try {
        const response = await PassengerService.getAnswereById(passengerId, 3);
        rootStore.passengerDetailStore.setCroniDisease(response[0].answer);
      } catch(error) {
        console.log("Error in get answer 1 in passenger detail.",error);
      }
    })();

    (async () => {
      try {
        const response = await PassengerService.getAnswereById(passengerId, 4);
        rootStore.passengerDetailStore.setImpaired(response[0].answer);
      } catch (error) {
        console.log("Error in get answer 2 in passenger detail.",error);
      }
    })();

    (async () => {
      try {
        let response = await PassengerService.getQuestionList();
        rootStore.passengerDetailStore.setQuestionList(response);
      } catch (error) {
        console.log("Error in get question list in passenger detail.",error);
      }
    })();
  },[]);

  useEffect(() => {
    (async () => {
      let userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        rootStore.passengerDetailStore.setRolename(JSON.parse(userInfo).roleLabel.toLowerCase());
      }
    })();
  }, []);
  const passId = Number()+1;

  const onBackClick = (passId) => {
   if (rootStore.passengerDetailStore.getRoleName == "ems") {
    if (rootStore.emsStore.getSelectedEmergency) {
      navigate(`/ems/medical-emergencies/emergency/${rootStore.emsStore.getSelectedEmergency?.id}`)
    }
   } else {
     navigate("/passengers")
   }
  }

  return (
    <div className="passenger-page">
      <div className="passenger-details">
        <div className='left-header'>
          <img src={arrow} onClick={() => onBackClick(passengerId)} alt="arrow" />
          <Text className="heading">Passenger's Detail</Text>
        </div>
        <div className='right-header'>
          <Box direction="row" align='center'>
            <Text style={{ fontSize: "13px", fontWeight: "bold", color: "#4B628A" }}>Last Update:</Text>
            <Text style={{ fontSize: "13px", fontWeight: "600", marginLeft: "8px", marginTop: 0 }}>{rootStore.passengerDetailStore.getPassenegr?.updatedAt}</Text>
          </Box>
          {/* <Box direction="row" align='center' style={{marginTop: 10}}>
            <Text style={{ fontSize: "13px", fontWeight: "bold", color: "#4B628A" }}>Tail Number:</Text>
            <Text style={{ fontSize: "13px", fontWeight: "600", marginLeft: "8px", marginTop: 0 }}>{rootStore.passengerDetailStore.getPassenegr?.updatedAt}</Text>
          </Box> */}
        </div>
      </div>

        <div className='card-container'>
          <div className='passenger-detail-card'>
            <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={badge} alt="arrow" />
                </div>
                  <Text className='detail-label'>Name</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.name || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={age} alt="arrow" />
                </div>
                  <Text className='detail-label'>Age</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.age || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={transgender} alt="arrow" />
                </div>
                  <Text className='detail-label'>Gender</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.gender || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={seat} alt="arrow" />
                </div>
                  <Text className='detail-label'>Impaired</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getImpaired || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={seat} alt="arrow" />
                </div>
                  <Text className='detail-label'>Chronic Disease</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getCroniDisease || "Not Specified"}</Text>
              </div>
            </div>
          </div>
          <div className='passenger-detail-card'>
            {
              rootStore.passengerDetailStore.getRoleName !== "admin" && (
            <div className="detail-item mb-14">
            <div className='left'>
              <div className="icon-bg-shap">
                <img style={{ width: "24px" }} src={org} alt="arrow" />
              </div>
                <Text className='detail-label'>Organization</Text>
            </div>
            <div className='right'>
            <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.orgName || "Not Specified"}</Text>
            </div>
          </div>
              )
            }
          <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={Email} alt="arrow" />
                </div>
                  <Text className='detail-label'>Email</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.email || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item mb-14">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={number} alt="arrow" />
                </div>
                  <Text className='detail-label'>Contact No.</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.contactNumber || "Not Specified"}</Text>
              </div>
            </div>
            <div className="detail-item">
              <div className='left'>
                <div className="icon-bg-shap">
                  <img style={{ width: "24px" }} src={address} alt="arrow" />
                </div>
                  <Text className='detail-label'>Address</Text>
              </div>
              <div className='right'>
              <Text className='detail-label'>{rootStore.passengerDetailStore.getPassenegr.address || "Not Specified"}</Text>
              </div>
            </div>
          </div>
        </div>
      {/* Questionnaire Section */}
      <div className="questionnaire">
        <div className="App">
        {rootStore.passengerDetailStore.getQuestionList.map((item) => (
          <Accordion key={item.id} title={item.question} questionId={item.id} />
        ))}
      </div>
      </div>
    </div>
  );
}

export default observer(PassengerDetails);
